<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" id="exigencia-obras-tab" data-toggle="tab" href="#exigencia-obras" role="tab"
      aria-controls="exigencia-obras" aria-selected="true">Exigências de Obras</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="licenca-ambiental-tab" data-toggle="tab" href="#licenca-ambiental" role="tab"
      aria-controls="licenca-ambiental" aria-selected="true">Licença Ambiental</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane fade show active" id="exigencia-obras" role="tabpanel" aria-labelledby="exigencia-obras-tab">
    <div class="row">
      <div class="col-12">
        <p-fieldset legend="Exigências de Obras">
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Consta nos autos o relatório de impacto ambiental? (Quando tratar-se de obra modificadora do meio ambiente
              - Lei 8.666/93, art. 12 e Resolução CONAMA 001, de 23.01.86, art.2º)
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ExisteRelatorioImpactoAmbiental" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required float-left col-9">
              O projeto da obra contempla as exigências contidas nos artigos 11 a 14 da Lei Estadual nº 11.263/02, de
              forma a assegurar o acesso de pessoas portadoras de deficiência ou com mobilidade reduzida? (banheiros
              acessíveis, rampas de acesso, elevadores acessíveis, etc.)
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ObraContemplaExigenciasArtigosEstadual1126302" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Consta nos autos o alvará de construção da obra?
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ConstaAlvaraConstrucaoObra" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Trata-se de obra rodoviária ou de saneamento?
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ObraRodoviariaSaneamentoNao" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label" *ngIf="arquivo.ObraRodoviariaSaneamentoNao === 'S'">
            <label class="required float-left col-9">
              Houve levantamento das condições físicas das áreas selecionadas?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ObraRodoviariaSaneamentoSim.HouveLevantamentoCondicoesFisicasAreasSelecionadas"
              [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label" *ngIf="arquivo.ObraRodoviariaSaneamentoNao === 'S'">
            <label class="required float-left col-9">
              Na definição dessas áreas foram adotados critérios técnicos contidos no art. 6º, IX da lei 8666/93?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ObraRodoviariaSaneamentoSim.AreasSelecionadasAdotadosCriteriosTecnicosArt6IXLei866693"
              [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Num conjunto de obras, para um mesmo fim, houve padronização por tipo ou classe de acordo com o projeto?
              (Lei 8.666/93, art. 11)?
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.HouvePadronizacaoTipoClasseArt11Lei866693" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required float-left col-9">
              Há Anotações da Responsabilidade Técnica ? ART, do CREA, do responsável técnico pela obra?
            </label>
            <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
              [(ngModel)]="arquivo.ExisteAnotacoesResponsabilidadeTecnicaART" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="row col-form-label">
            <label class="required col-4 col-form-label">
              Data da emissão da 1º (primeira) Ordem de Serviço
            </label>
            <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.DataEmissaoOrdemServico_Dt"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
  <div class="tab-pane fade" id="licenca-ambiental" role="tabpanel" aria-labelledby="licenca-ambiental-tab">
    <p-fieldset legend="Licença Ambiental">
      <div class="row col-form-label">
        <label class="required float-left col-3">
          Existe licença ambiental?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.LicencaAmbientalNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <lib-licitacao-audesp-licenca-ambiental *ngIf="arquivo.LicencaAmbientalNao === 'S'" [exigenciaObras]="arquivo">
      </lib-licitacao-audesp-licenca-ambiental>
    </p-fieldset>
  </div>
</div>